import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MessageToast from "../components/MessageToast";

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  }

  return ComponentWithRouterProp;
}

export const openLinkInNewTab = (url) => {
  if (url) {
    return window.open(url ? url : "https://demand.noneho.com/");
  }

  return (
    <MessageToast message="Link not provided" type="warning" duration={3000} />
  );
};

export const getAcceptedColor = (colorIndex) => {
  const accepted_colors = [
    {
      mainColor: "rgb(209, 0, 116)",
      bgColor: "rgb(209, 0, 116, 0.2)",
      hexColor: "#d10074",
    },
    {
      mainColor: "rgb(236, 194, 0)",
      bgColor: "rgb(236, 194, 0, 0.2)",
      hexColor: "#ecc200",
    },
    {
      mainColor: "rgb(255, 161, 0)",
      bgColor: "rgb(255, 161, 0, 0.2)",
      hexColor: "#ffa100",
    },
    {
      mainColor: "rgb(128, 55, 155)",
      bgColor: "rgb(128, 55, 155, 0.2)",
      hexColor: "#80379b",
    },
    {
      mainColor: "rgb(61, 183, 228)",
      bgColor: "rgb(61, 183, 228, 0.2)",
      hexColor: "#3db7e4",
    },
    {
      mainColor: "rgb(201, 214, 0)",
      bgColor: "rgb(201, 214, 0, 0.2)",
      hexColor: "#c9d600",
    },
    {
      mainColor: "rgb(77, 19, 83)",
      bgColor: "rgb(77, 19, 83, 0.2)",
      hexColor: "#4d1353",
    },
    {
      mainColor: "rgb(0, 113, 97)",
      bgColor: "rgb(0, 113, 97, 0.2)",
      hexColor: "#007161",
    },
    {
      mainColor: "rgb(151, 0, 94)",
      bgColor: "rgb(151, 0, 94, 0.2)",
      hexColor: "#97005e",
    },
  ];

  return colorIndex >= 0
    ? accepted_colors[colorIndex]
    : accepted_colors[Math.floor(Math.random() * accepted_colors.length)];
};
